const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function gettinThemFilez(url) {
    return function() {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "marketingurl.csv";
                a.click();  
            });
        });
    };
}

const MarketingURLForm = React.createClass({
    render() {
        return (<div>
            Marketing URL template file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={gettinThemFilez(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = MarketingURLForm;


// WEBPACK FOOTER //
// ./src/components/metadata/MarketingURLForm.jsx